import { Component } from '@theme/component';

/**
 * @typedef {object} AiArtworkGuideRefs
 * @property {HTMLTextAreaElement} promptInput
 * @property {HTMLButtonElement} copyButton
 * @property {HTMLElement} copyStatus
 */

/** @extends Component<AiArtworkGuideRefs> */
class AiArtworkGuide extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.refs.copyButton.disabled = false;
  }

  /** @param {Event} event */
  toggleGuides(event) {
    if (event.target instanceof HTMLInputElement) this.dataset.guides = String(event.target.checked);
  }

  async copyPrompt() {
    const { promptInput, copyButton, copyStatus } = this.refs;
    copyButton.disabled = true;
    try {
      await navigator.clipboard.writeText(promptInput.value);
      copyStatus.textContent = this.dataset.copiedText || '';
    } catch {
      promptInput.focus();
      promptInput.select();
      copyStatus.textContent = this.dataset.copyFailedText || '';
    } finally {
      copyButton.disabled = false;
    }
  }
}

if (!customElements.get('ai-artwork-guide')) customElements.define('ai-artwork-guide', AiArtworkGuide);
